(function () {
  'use strict';

  var sections = document.querySelectorAll('[data-dietitian-form-card]');

  sections.forEach(function (root) {
    var form = root.querySelector('[data-dfc-form]');
    if (!form) {
      console.warn('[dietitian-form-card] Could not find the form element (data-dfc-form). Aborting.');
      return;
    }

    var errorEl = root.querySelector('[data-dfc-error]');
    var submitBtn = root.querySelector('[data-dfc-submit]');
    var submitLabel = root.querySelector('[data-dfc-submit-label]');
    var successEl = root.querySelector('[data-dfc-success]');
    var nameInput = form.querySelector('[name="name"]');
    var whatsappInput = form.querySelector('[name="whatsapp"]');
    var emailInput = form.querySelector('[name="email"]');
    var locationInput = form.querySelector('[name="location"]');
    var webhookUrl = root.dataset.webhookUrl || '';
    var originalLabel = submitLabel ? submitLabel.textContent : '';

    var missing = [];
    if (!errorEl) missing.push('data-dfc-error');
    if (!submitBtn) missing.push('data-dfc-submit');
    if (!successEl) missing.push('data-dfc-success');
    if (!nameInput) missing.push('[name="name"]');
    if (!whatsappInput) missing.push('[name="whatsapp"]');
    if (!locationInput) missing.push('[name="location"]');

    if (missing.length) {
      console.warn('[dietitian-form-card] Missing expected elements, aborting submit handler:', missing.join(', '));
      return;
    }

    function isValidWhatsapp(value) {
      var digits = value.replace(/[^0-9]/g, '');
      return digits.length >= 8;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      errorEl.classList.remove('is-visible');

      var name = nameInput.value.trim();
      var whatsapp = whatsappInput.value.trim();
      var email = emailInput ? emailInput.value.trim() : '';
      var location = locationInput.value.trim();

      if (!name || !whatsapp || !location || !isValidWhatsapp(whatsapp)) {
        errorEl.classList.add('is-visible');
        return;
      }

      submitBtn.disabled = true;
      if (submitLabel) submitLabel.textContent = 'Submitting…';

      var payload = {
        name: name,
        whatsapp: whatsapp,
        email: email,
        location: location
      };

      function showSuccess() {
        form.hidden = true;
        successEl.hidden = false;
      }

      if (!webhookUrl) {
        showSuccess();
        return;
      }

      var settled = false;

      function complete() {
        if (settled) return;
        settled = true;
        showSuccess();
      }

      // Apps Script web apps sometimes never resolve the fetch Promise back to
      // the client under mode:'no-cors', even though the request completes
      // server-side. Since no-cors also means the response body/status can't
      // be read anyway, fall back to assuming success after a short timeout
      // instead of leaving the button stuck indefinitely.
      window.setTimeout(complete, 4000);

      fetch(webhookUrl, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify(payload)
      })
        .then(complete)
        .catch(function (err) {
          if (settled) return;
          settled = true;
          console.error('[dietitian-form-card] Webhook submission failed:', err);
          submitBtn.disabled = false;
          if (submitLabel) submitLabel.textContent = originalLabel;
          errorEl.textContent = 'Something went wrong. Please try again.';
          errorEl.classList.add('is-visible');
        });
    });
  });
})();